import { Phone, MessageSquare, Calendar, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL, BOOKING_URL, SUPPORT_DIRECTOR } from "@/lib/supportContent";
import { Link } from "react-router-dom";

const StickyEmergencyBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0A1828]/95 border-t border-primary/30 backdrop-blur-xl shadow-[0_-8px_30px_rgba(0,0,0,0.5)]">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-center md:text-left">
          <p className="text-xs uppercase tracking-wider text-primary font-semibold">Need help right now?</p>
          <p className="text-sm text-white">
            24/7 Customer Support · <a href={SUPPORT_PHONE_TEL} className="font-bold text-primary hover:underline">{SUPPORT_PHONE}</a>
            <span className="hidden sm:inline text-muted-foreground"> · Director: {SUPPORT_DIRECTOR}</span>
          </p>
        </div>
        <div className="flex flex-wrap gap-2 justify-center">
          <Button asChild size="sm" className="bg-gradient-to-r from-[#00F5A0] to-[#00D9F5] text-[#05070A] font-semibold">
            <a href={SUPPORT_PHONE_TEL}><Phone className="w-4 h-4 mr-1.5" /> Call Now</a>
          </Button>
          <Button asChild size="sm" variant="outline" className="border-primary/40 text-white">
            <Link to="/portal/support?new=ticket"><Ticket className="w-4 h-4 mr-1.5" /> Open Ticket</Link>
          </Button>
          <Button asChild size="sm" variant="outline" className="border-primary/40 text-white hidden sm:inline-flex">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer"><Calendar className="w-4 h-4 mr-1.5" /> Book Service</a>
          </Button>
          <Button size="sm" variant="outline" className="border-primary/40 text-white" onClick={() => window.dispatchEvent(new CustomEvent("open-support-chat"))}>
            <MessageSquare className="w-4 h-4 mr-1.5" /> Live Chat
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyEmergencyBar;
